<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="订单ID｛order.id｝" prop="orderId" >-->
<!--        <a-input v-model="form.orderId" placeholder="请输入订单ID｛order.id｝" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="状态" prop="status" >
        <span v-if="form.status == 0">待支付</span>
        <span v-if="form.status == 1">已支付</span>
        <span v-if="form.status == 2">已发货</span>
        <span v-if="form.status == 3">已完成</span>
        <span v-if="form.status == 4">已售后</span>
        <span v-if="form.status == 5">待评价</span>
        <span v-if="form.status == -1">已取消</span>
      </a-form-model-item>
<!--      <a-form-model-item label="支付方式(1积分兑换 2现金交易 3积分加现金4现金加现金券)" prop="payMethod" >-->
<!--        <a-input v-model="form.payMethod" placeholder="请输入支付方式(1积分兑换 2现金交易 3积分加现金4现金加现金券)" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="支付时间" prop="payTime" v-if="form.status !=-1 && form.status != 0">
        <a-date-picker disabled style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="支付类型" prop="payType"  v-if="form.status !=-1 && form.status != 0">
        <span v-if="form.payType == 0">余额</span>
        <span v-if="form.payType == 1">PayPal</span>
        <span v-if="form.payType == 2">支付宝</span>
      </a-form-model-item>
<!--      <a-form-model-item label="商品ID" prop="productId" >-->
<!--        <a-input v-model="form.productId" placeholder="请输入商品ID" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="商品数量" prop="quantity" >
        <a-input disabled v-model="form.quantity" placeholder="请输入商品数量" />
      </a-form-model-item>
      <a-form-model-item label="商品名称" prop="productName" >
        <a-input disabled v-model="form.productName" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="skuID" prop="skuId" >-->
<!--        <a-input v-model="form.skuId" placeholder="请输入skuID" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="规格名称" prop="skuName" >
        <a-input disabled v-model="form.skuName" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price" >
        <a-input disabled v-model="form.price" placeholder="请输入价格" />
      </a-form-model-item>
      <a-form-model-item label="商品图片" prop="image" >
         <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.image"
              :src="form.image" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="消耗现金券额度" prop="reduceVoucher" >
        <a-input disabled v-model="form.reduceVoucher" placeholder="请输入消耗现金券额度" />
      </a-form-model-item>
<!--      <a-form-model-item label="消耗积分数" prop="reduceScores" >-->
<!--        <a-input disabled v-model="form.reduceScores" placeholder="请输入消耗积分数" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="运费" prop="freight" >
        <a-input disabled v-model="form.freight" placeholder="请输入运费" />
      </a-form-model-item>
      <a-form-model-item label="物流公司" prop="logisticsCompany" v-if="form.status==1 || form.logisticsCompany">
        <a-input :disabled="isInfo==true" v-model="form.logisticsCompany" placeholder="请输入物流公司" />
      </a-form-model-item>
      <a-form-model-item label="物流单号" prop="logisticsNumber" v-if="form.status==1 || form.logisticsNumber">
        <a-input :disabled="isInfo==true" v-model="form.logisticsNumber" placeholder="请输入物流单号" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button v-if="!isInfo" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrderItem, addOrderItem, updateOrderItem,editLogistics } from '@/api/orderItem/orderItem'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:false,
      // 表单参数
      form: {
        id: null,

        orderId: null,

        status: 0,

        payMethod: null,

        payTime: null,

        payType: null,

        productId: null,

        quantity: null,

        productName: null,

        skuId: null,

        skuName: null,

        price: null,

        image: null,

        reduceVoucher: null,

        reduceScores: null,

        freight: null,

        logisticsCompany: null,

        logisticsNumber: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.isInfo = false
      this.form = {
        id: null,
        orderId: null,
        status: 0,
        payMethod: null,
        payTime: null,
        payType: null,
        productId: null,
        quantity: null,
        productName: null,
        skuId: null,
        skuName: null,
        price: null,
        image: null,
        reduceVoucher: null,
        reduceScores: null,
        freight: null,
        logisticsCompany: null,
        logisticsNumber: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderItem({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleInfo (row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getOrderItem({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.isInfo = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            editLogistics({id:this.form.id,orderId:this.form.orderId,
              logisticsCompany: this.form.logisticsCompany,
              logisticsNumber: this.form.logisticsNumber}).then(res => {
                if(res.success){
                  this.$message.success(
                    '操作成功',
                    3
                  )
                  this.open = false
                  this.$emit('ok')
                }else{
                 this.$message.error(
                   res.message,
                   3
                 )
                }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrderItem(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
